
import { supabase } from "@/integrations/supabase/client";
import { v4 as uuidv4 } from 'uuid';

export const articleTagService = {
  async updateArticleTags(articleId: string, tagNames: string[]) {
    try {
      // First, ensure all tags exist in the tags table
      const tagPromises = tagNames.map(async (tagName) => {
        // Generate a slug from the tag name
        const slug = tagName.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
        
        // Check if tag already exists
        const { data: existingTag } = await supabase
          .from('tags')
          .select('id')
          .eq('name', tagName)
          .maybeSingle();

        if (existingTag) {
          return existingTag.id;
        } else {
          // Create new tag
          const { data: newTag, error } = await supabase
            .from('tags')
            .insert({ name: tagName, slug })
            .select('id')
            .single();

          if (error) throw error;
          return newTag?.id;
        }
      });

      const tagIds = await Promise.all(tagPromises);

      // Remove existing article-tag associations
      await supabase
        .from('article_tags')
        .delete()
        .eq('article_id', articleId);

      // Create new article-tag associations
      const articleTagsData = tagIds.map(tagId => ({
        id: uuidv4(),
        article_id: articleId,
        tag_id: tagId
      }));

      const { error } = await supabase
        .from('article_tags')
        .insert(articleTagsData);

      if (error) throw error;

      return { success: true, error: null };
    } catch (error) {
      console.error('Error updating article tags:', error);
      return { success: false, error };
    }
  }
};
